import { Injectable } from '@angular/core';
import { ProgramRole } from 'src/app/shared/enums/program-role.enum';
import { AclItemApiModel } from '@app/api/api-models/AclItemApiModel';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class HideEditService {
  private hideFromTrainersControl: AbstractControl;
  private hideFromSupervisorsControl: AbstractControl;
  private canHideFromTrainers = true;
  private canHideFromSupervisors = true;

  public filterByHideFromTrainers = false;
  public filterByHideFromSupervisors = false;

  public setHideFromTrainersControl(control: AbstractControl, acl: Array<AclItemApiModel>, error: string): void {
    this.hideFromTrainersControl = control;
    this.filterByHideFromTrainers = control.value;

    this.hideFromTrainersControl.setValidators(
      CustomValidators.customErrorValidator({
        validator: CustomValidators.customValidator((value) => !value || this.canHideFromTrainers),
        errors: {
          predicateError: error
        }
      })
    );

    this.stepsChanged(acl);
  }

  public setHideFromSupervisorsControl(control: AbstractControl, acl: Array<AclItemApiModel>, error: string): void {
    this.hideFromSupervisorsControl = control;
    this.filterByHideFromSupervisors = control.value;

    this.hideFromSupervisorsControl.setValidators(
      CustomValidators.customErrorValidator({
        validator: CustomValidators.customValidator((value) => !value || this.canHideFromSupervisors),
        errors: {
          predicateError: error
        }
      })
    );

    this.stepsChanged(acl);
  }

  public reset(): void {
    this.hideFromTrainersControl = null;
    this.hideFromSupervisorsControl = null;
    this.filterByHideFromTrainers = false;
    this.filterByHideFromSupervisors = false;
  }

  public stepsChanged(acl: Array<AclItemApiModel>): void {
    this.canHideFromTrainers = !acl.some((y) => y.ProgramRole === ProgramRole.Trainer);
    this.canHideFromSupervisors = !acl.some((y) => y.ProgramRole === ProgramRole.Supervisor);

    this.hideFromTrainersControl?.updateValueAndValidity();
    this.hideFromSupervisorsControl?.updateValueAndValidity();

    if (this.canHideFromTrainers) {
      this.hideFromTrainersControl?.enable();
    }

    if (this.canHideFromSupervisors) {
      this.hideFromSupervisorsControl?.enable();
    }

    if (!this.canHideFromTrainers && this.hideFromTrainersControl?.valid) {
      this.hideFromTrainersControl?.disable();
    }

    if (!this.canHideFromSupervisors && this.hideFromSupervisorsControl?.valid) {
      this.hideFromSupervisorsControl?.disable();
    }
  }

  public hideFromTrainersChanged(value: boolean): void {
    this.filterByHideFromTrainers = value;
  }

  public hideFromSupervisorsChanged(value: boolean): void {
    this.filterByHideFromSupervisors = value;
  }
}
